import React from "react";
import NavSection from "@/src/components/locate-us/nav-section/navbar";
import { centreApiService } from "@/src/lib/api-services/centreApiServices";
import Iconify from "@/src/components/iconify";

import Progressbar from "../loading";
import IconCode from "@/src/lib/iconCode";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";

const defaultConfig = {
    itemGap: 4,
    iconSize: 24,
    currentRole: "admin",
    itemRootHeight: 44,
    itemSubHeight: 36,
    itemPadding: "4px 8px 4px 12px",
    itemRadius: 8,
    hiddenLabel: false,
};

const convertToNavItems = (data) => {
    return data?.map((state) => ({
        subheader: state.stateName,
        items: state?.cityDetails?.map((city) => ({
            title: city.cityName,
            path: `/${city.citySlug}`,
            icon: <Iconify icon={IconCode?.mapTo} width={18} />,
            children: city.centres.map((centre) => ({
                title: centre.centreName,
                path: `/locate-us/${centre.urlSlug}`,
                icon:
                    centre.centreTypeId === 1 ? (
                        <Iconify icon={IconCode?.labMarker2} width={18} />
                    ) : (
                        <Iconify icon={IconCode?.labMarker1} width={18} />
                    ),
                caption:
                    centre.centreTypeId === 1
                        ? "Diagnostic Centre"
                        : "Collection Centre", // static caption using centreType
                routePath: `/${centre.urlSlug}`,
            })),
        })),
    }));
};

const CentreNavBar = ({ currentPath, apiEndpoint, config = defaultConfig }) => {
    // Fetch data using the API
    const { data, isLoading, isError, error } = useCustomQuery(
        ["centre_list"],
        () => centreApiService.centreList(),
        {
            enabled: true,
        }
    );

    // Render skeleton loaders if data is loading
    if (isLoading) {
        return (
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col gap-2 justify-center items-center h-full">
                    <Progressbar size={40} />
                </div>
            </div>
        );
    }

    if (isError) return <div>Error: {error.message}</div>;

    const NAV_ITEMS = convertToNavItems(data?.data);

    return (
        <NavSection
            data={NAV_ITEMS}
            config={config}
            currentPath={currentPath}
            className="py-0"
        />
    );
};

export default CentreNavBar;
